import { gql } from '@apollo/client'

export const GET_SITE = gql`
  query GetSite($siteId: ID!) {
    site(input: { id: $siteId }) {
      id
      name
      type
      company {
        id
        name
      }
      address {
        line1
        line2
        city
        zipCode
        stateCode
        countryCode
      }
      users {
        id
        firstName
        lastName
        username
      }
      settings {
        snacks {
          canSell
          showMinPrice
          tripRequired
        }
        kredits {
          canTopUp
        }
        defaultOrigin {
          id
          name
        }
        passengerNameRequired
        hasPrinter
        payment
        saleClosingThreshold
        canChangePrice
        enabledCompanyLines {
          id
        }
        canReserveTickets
        enableMixedPayments
        hideTransactionsReport
      }
    }
  }
`

export const GET_SITES_AUTOCOMPLETE = gql`
  query GetSitesAutocomplete($limit: Int!) {
    sitesAutocomplete(input: { limit: $limit }) {
      id
      name
      companyID
    }
  }
`
